import { buildElementId } from '../utils';

import {
  ValidateNumeric,
  ValidateRegExp,
  ValidateSelector,
  ValidateSegmented,
} from './ElementValidators';

const getValue = (answer) => {
  return (answer || { value: '' }).value;
};

const date = new Date();
let year = date.getFullYear() + 1;

const validateWaterPipeSystem = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSegmented(
    getValue(questions.waterPipeSystem),
    buildElementId(id, 'HOME_WATERPIPESYSTEM'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.waterPipeSystem?.question ||
          getMessage('labelText.waterPipeSystem')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (getValue(questions.waterPipeSystem) !== 'Yes') {
    newErrors = {
      ...newErrors,
      remove: [
        ...newErrors.remove,
        buildElementId(id, 'HOME_YEAROFWATERPIPESYSTEM'),
      ],
    };
  }

  return newErrors;
};

const validateHeatingSystem = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSelector(
    getValue(questions.heatingSystem),
    buildElementId(id, 'HOME_HEATINGSYSTEM'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.heatingSystem?.question ||
          getMessage('labelText.heatingSystem')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );

  if (getValue(questions.heatingSystem) !== 'Hydronic radiant heat') {
    newErrors = {
      ...newErrors,
      remove: [
        ...newErrors.remove,
        buildElementId(id, 'HOME_YEAROFHEATINGSYSTEM'),
      ],
    };
  }

  return newErrors;
};

const homewithoutArea = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  const homesWithOutArea = [
    'House',
    'Agricultural building',
    'Sauna',
    'Free-time residence',
  ];
  if (homesWithOutArea.indexOf(getValue(questions.homeType)) > -1) {
    newErrors = validateWaterPipeSystem(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validateHeatingSystem(newErrors, id, questions, validateAll, questionID, caption, getMessage);

    newErrors = ValidateSelector(
      getValue(questions.electricityType),
      buildElementId(id, 'HOME_ELECTRICITYTYPE'),
      newErrors,
      validateAll,
      questionID,
      getMessage
        ? `${caption} : ${
            questions.electricityType?.question ||
            getMessage('labelText.electricityType')
          } - ${getMessage('error.fill.in.missing.information')}`
        : ''
    );
  }
  return newErrors;
};

const validateAddress = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let addressMessage =
    questions.address?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.address?.question ||
          getMessage('labelText.HomeAddress')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  addressMessage = addressMessage.replace(
    '- undefined',
    (getMessage ?? questions.homeType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.address),
    id: buildElementId(id, 'HOME_ADDRESS'),
    newErrors,
    validateAll,
    length: 1,
    questionID,
    regExp:
      "(^[0-9a-zA-Z\\u00C0-\\u017F'´`]+([ |-][0-9a-zA-Z\\u00C0-\\u017F'´`]+)*$)|(^$)",
    errorLabel: addressMessage,
  });
  return newErrors;
};

const validatePostcode = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let postcodeMessage =
    questions.postcode?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.postcode?.question ||
          getMessage('labelText.postcode')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  postcodeMessage = postcodeMessage.replace(
    '- undefined',
    (getMessage ?? questions.homeType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateRegExp({
    value: getValue(questions.postcode),
    id: buildElementId(id, 'HOME_POSTCODE'),
    newErrors,
    validateAll,
    length: 5,
    questionID,
    regExp: '(^[0-9]{5}$)|(^$)',
    errorLabel: postcodeMessage,
  });
  return newErrors;
};

const validateFloorArea = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  let floorareaMessage =
    questions.postcode?.errorLabel ||
    (getMessage
      ? `${caption} : ${
          questions.floorarea?.question ||
          getMessage('labelText.floorArea')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '');
  floorareaMessage = floorareaMessage.replace(
    '- undefined',
    (getMessage ?? questions.homeType.getMessage)(
      'error.fill.in.missing.information'
    )
  );
  newErrors = ValidateNumeric(
    getValue(questions.floorarea),
    buildElementId(id, 'HOME_FLOORAREA'),
    newErrors,
    validateAll,
    1,
    9999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    floorareaMessage
  );
  return newErrors;
};

const validateTotalFloorArea = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateNumeric(
    getValue(questions.totalfloorarea),
    buildElementId(id, 'HOME_TOTALFLOORAREA'),
    newErrors,
    validateAll,
    1,
    9999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.totalfloorarea?.question ||
          getMessage('labelText.totalFloorArea')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateTotalFloorAreaDetached = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateNumeric(
    getValue(questions.totalfloorareadetached),
    buildElementId(id, 'HOME_TOTALFLOORAREA_DETACHED'),
    newErrors,
    validateAll,
    1,
    9999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.totalfloorareadetached?.question ||
          getMessage('labelText.totalFloorAreaOwnHomeSemi-detached')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateConstructionYear = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateNumeric(
    getValue(questions.constructionYear),
    buildElementId(id, 'HOME_CONSTRUCTIONYEAR'),
    newErrors,
    validateAll,
    1700,
    year,
    questionID,
    '^([1-9][0-9]{0,3})$',
    getMessage
      ? `${caption} : ${
          questions.constructionYear?.question ||
          getMessage('labelText.constructionYear')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validatePurposeOfUse = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateSelector(
    getValue(questions.purposeofuse),
    buildElementId(id, 'HOME_PURPOSEOFUSE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
          questions.purposeofuse?.question ||
          getMessage('labelText.purposeOfUse')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const validateMonthlyRent = (newErrors, id, questions, validateAll, questionID, caption, getMessage) => {
  newErrors = ValidateNumeric(
    getValue(questions.monthlyRent),
    buildElementId(id, 'HOME_MONTHLY_RENT'),
    newErrors,
    validateAll,
    1,
    999999,
    questionID,
    '^[1-9]\\d*(?:\\.\\d{1,2})?$',
    getMessage
      ? `${caption} : ${
          questions.monthlyRent?.question ||
          getMessage('labelText.monthlyRent')
        } - ${getMessage('error.fill.in.missing.information')}`
      : ''
  );
  return newErrors;
};

const doesTotalFloorAreaNeedsValidating = (homesWithOutArea, questions) => {
  return (homesWithOutArea.indexOf(getValue(questions.homeType)) > -1 &&
  getValue(questions.housingcompany) === '') ||
(getValue(questions.housingcompany) === 'No' &&
  getValue(questions.homeType) !== 'Duplex')
}

const validateHome = (
  newErrors,
  id,
  questions,
  validateAll,
  questionID,
  caption,
  getMessage
) => {
  const homesWithArea = [
    'Apartment building',
    'Terraced house',
    'Detached house',
    'Duplex',
  ];
  const homesWithOutArea = [
    'House',
    'Agricultural building',
    'Sauna',
    'Free-time residence',
  ];

  const validateTotalFloorAreaQuestion = doesTotalFloorAreaNeedsValidating(homesWithOutArea, questions)

  if (
    getValue(questions.homeType) !== 'choose' &&
    getValue(questions.homeType) !== ''
  ) {
    newErrors = validateAddress(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    newErrors = validatePostcode(newErrors, id, questions, validateAll, questionID, caption, getMessage);

    // Floor Area
    if (
      (homesWithArea.indexOf(getValue(questions.homeType)) > -1 &&
        getValue(questions.housingcompany) === '') ||
      getValue(questions.housingcompany) === 'Yes'
    ) {
      newErrors = validateFloorArea(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    }

    // Total Floor Area
    if (validateTotalFloorAreaQuestion) {
      newErrors = validateTotalFloorArea(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    }
    if (
      getValue(questions.housingcompany) === 'No' &&
      getValue(questions.homeType) === 'Duplex'
    ) {
      newErrors = validateTotalFloorAreaDetached(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    }

    // Construction year
    newErrors = validateConstructionYear(newErrors, id, questions, validateAll, questionID, caption, getMessage);

    // Purpose of use
    newErrors = validatePurposeOfUse(newErrors, id, questions, validateAll, questionID, caption, getMessage);
    
    // Monthly rent
    if(getValue(questions.purposeofuse) === '3') {
      newErrors = validateMonthlyRent(newErrors, id, questions, validateAll, questionID, caption, getMessage)
    }
  }

  newErrors = homewithoutArea(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );

  return {
    add: newErrors.add.filter(Boolean),
    remove: newErrors.remove.filter(Boolean),
  };
};

const validateHomeQuestions = (
  id,
  questions,
  validateAll,
  questionID,
  errors,
  caption,
  getMessage
) => {
  let newErrors = { add: [], remove: [] };
  const homeType = questions.homeType || { value: '' };
  // Mandatory, validate always type
  newErrors = ValidateSelector(
    homeType.value,
    buildElementId(id, 'HOME_TYPE'),
    newErrors,
    validateAll,
    questionID,
    getMessage
      ? `${caption} : ${
         homeType.question || getMessage('labelText.homeType')
        } - ${getMessage('error.fill.in.missing.information')}`
      : '' 
  );

  if (validateAll === true && homeType.value === 'choose') {
    newErrors.remove = [
      ...newErrors.remove,
      ...errors
        .filter(
          (record) =>
            record.id.indexOf(id) !== -1 && record.id !== id + '_HOME_TYPE'
        )
        .map((record) => record.id),
    ];
  }
  return validateHome(
    newErrors,
    id,
    questions,
    validateAll,
    questionID,
    caption,
    getMessage
  );
};

export default validateHomeQuestions;
